import smoothscroll from 'smoothscroll-polyfill';
import "@hotwired/turbo-rails"
import "./controllers"
import "./actions"
import tippy from 'tippy.js';


smoothscroll.polyfill();

document.addEventListener("turbo:load", () => {
  tippy('[data-tippy-content]', { maxWidth: 200 });
})

document.addEventListener("click", (event) => {
  if (event.target.tagName == "A") {
    const destination = event.target.getAttribute("href")
    if (destination.startsWith("#")) {
      const element = document.getElementById(destination.slice(1))
      element.scrollIntoView({ behavior: "smooth" });
      event.preventDefault()
      return false
    } else if (destination.startsWith(location.pathname + "#")) {
      const element = document.getElementById(destination.split("#")[1])
      element.scrollIntoView({ behavior: "smooth" });
      event.preventDefault()
    }
  }
})
